import React from 'react';
import './Card.css'; // Import the CSS file

function AdultCard({ person, onClick }) {
    return (
    <div className="card-container" onClick={onClick}>
      <div className="card-details">
        <h2>{person.adultName} {person.adultSurname}</h2>
        <p></p>
        <p>{person.id}</p>
        <p>{person.adultNationality}</p>
      </div>
    </div>
  );
}

export default AdultCard;
